type Notice = {
  message: string;
  stack?: string;
};

const ignoredNoticeMessages = [
  'Failed to load https://www.googletagmanager.com/gtag/js',
  'Promise.withResolvers is not a function'
];

const isGoogleFedCmUpdateError = (notice: Notice): boolean =>
  notice.message.includes('UnhandledPromiseRejectionWarning: Object Not Found Matching Id:') &&
  notice.message.includes('MethodName:update, ParamCount:4');

const isBrowserExtensionError = (notice: Notice): boolean => {
  const stack = notice.stack ?? '';
  return (
    stack.includes('chrome-extension://') ||
    stack.includes('moz-extension://') ||
    stack.includes('safari-web-extension://')
  );
};

// return false if you don't want the error to be reported
export const filterHoneybadgerNotices = (notice: Notice | undefined): boolean => {
  if (!notice) return true;

  if (isBrowserExtensionError(notice)) return false;
  if (isGoogleFedCmUpdateError(notice)) return false;

  return !ignoredNoticeMessages.some(message => notice.message.includes(message));
};
